import apiRoutes from "./apiRoutes";

const callDebugUploadEnabled = process.env.REACT_APP_CALL_DEBUG_UPLOAD !== "false";
const maxStringLength = 500;
const maxArrayLength = 12;
const maxDepth = 4;

function normalizeValue(value, depth = 0) {
    if (value === null || value === undefined) return value;
    if (depth > maxDepth) return "[max-depth]";

    if (value instanceof Error) {
        return {
            name: value.name,
            message: value.message,
        };
    }

    if (typeof value === "string") {
        return value.length > maxStringLength ? `${value.slice(0, maxStringLength)}...` : value;
    }

    if (["number", "boolean"].includes(typeof value)) {
        return value;
    }

    if (Array.isArray(value)) {
        return value.slice(0, maxArrayLength).map((item) => normalizeValue(item, depth + 1));
    }

    if (typeof value === "object") {
        return Object.entries(value).reduce((acc, [key, entryValue]) => {
            if (/token|authorization|credential|password|secret|sdp|candidate/i.test(key)) {
                acc[key] = "[redacted]";
                return acc;
            }
            acc[key] = normalizeValue(entryValue, depth + 1);
            return acc;
        }, {});
    }

    return String(value);
}

function parseCallIds(roomId = "") {
    if (roomId.startsWith("call:")) {
        const callId = Number(roomId.split(":", 2)[1]);
        return Number.isFinite(callId) ? { call_id: callId } : {};
    }

    if (roomId.startsWith("group-call:")) {
        const groupCallId = Number(roomId.split(":", 2)[1]);
        return Number.isFinite(groupCallId) ? { group_call_id: groupCallId } : {};
    }

    return {};
}

export function sendCallDebugLog(scope, event, payload = {}) {
    if (!callDebugUploadEnabled || typeof window === "undefined") return;

    const normalizedPayload = normalizeValue(payload) || {};
    const roomId = normalizedPayload.roomId || normalizedPayload.room_id || "";
    const body = {
        scope,
        event,
        room_id: roomId || null,
        ...parseCallIds(roomId),
        payload: normalizedPayload,
    };
    const token = localStorage.getItem("access_token");
    const headers = { "Content-Type": "application/json" };
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    fetch(`${apiRoutes.CHAT_URL}${apiRoutes.chat.callLogs}`, {
        method: "POST",
        headers,
        credentials: "include",
        keepalive: true,
        body: JSON.stringify(body),
    }).catch(() => {});
}
